<template>
  <div>
    <v-select ref="vue_select"
              v-model="selected"
              :getOptionLabel="opt => opt"
              @keypress.enter.native.prevent=""
              @input="select"
              :placeholder="preset.placeholder"
              :filterable="false"
              :options="options"
              @search="onSearch">
      <template slot="no-options">
        {{ preset.not_found }}
      </template>
      <template slot="option" slot-scope="option">
        <div class="d-center">
          {{ option.title }}
        </div>
      </template>
      <template slot="selected-option" slot-scope="option">
        {{ option.title }}
      </template>
    </v-select>
  </div>
</template>

<script>

import api from '@/api'
import vSelect from 'vue-select';

export default {
  props: ['searchType', 'customPreset', 'onSelect'],
  components: {
    vSelect
  },
  data() {
    return {
      preset: {
        placeholder: 'Начните печатать для поиска',
        not_found: 'Ничего не найдено'
      },
      selected: null,
      options: [],
      loading: false,
    }
  },
  created() {
    if (this.customPreset) {
      this.preset.placeholder = this.customPreset?.placeholder ?? this.preset.placeholder;
      this.preset.not_found = this.customPreset?.not_found ?? this.preset.not_found;
    }
  },
  methods: {
    select(e) {
      if (this.onSelect) {
        this.onSelect(e);
      }
    },
    onSearch(search, loading) {
      if (!search || search.length < 2) {
        this.searchLoading = false;
        return;
      }
      loading(true);
      this.search(loading, search, this);
    },
    search: _.debounce(async (loading, search, vm) => {
      if (!search) return;
      const {data} = await api.post('/new/search', {
        search,
        searchType: vm.searchType
      });
      if (data.success) {
        vm.options = data.records;
      } else {
        toastr['warning'](data.message ?? 'Ошибка сервера');
      }
      loading(false);
    }, 700),
  }
}

</script>
